// extracted by mini-css-extract-plugin
export default {"zoomControls":"Vca-z","zoomControlButton":"Wca-z","zoomBanner":"Xca-z","bannerButton":"Yca-z","imageButton":"Zca-z","zoom":"_ca-z","zoomContent":"ada-z"};